import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { SHOP_PATHS, Url } from '@wix/da-url';
import PromoBanner from '@wix/da-ds/pkg/PromoBanner';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import GreenShop from '@wix/da-ds/pkg/Icons/16x16/GreenShop';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';

interface Props {
  className?: string;
}

const GreenShopBanner: React.FC<Props> = ({ className }) => {
  const { t } = useTranslation();
  const isMobile = useContext(MobileContext);
  const isShopDefaultCommissionsFeatureEnabled = useFlag(
    'shop_default_commissions'
  );

  const link = isShopDefaultCommissionsFeatureEnabled
    ? Url.shopLink(SHOP_PATHS.COMMISSIONS)
    : t('browse.greenShopBanner.ctaLink');

  return (
    <PromoBanner
      className={className}
      size={isMobile ? 'small' : 'big'}
      variant="shop"
      icon={<GreenShop size={IconSize.SMALLER} />}
      messageAfterIcon={t('browse.greenShopBanner.message')}
      ctaLabel={t('browse.greenShopBanner.ctaLabel')}
      ctaHref={link}
      ctaBiData={{ evid: 2, sectionname: 'banner', click_info: 'shop' }}
    />
  );
};
GreenShopBanner.displayName = 'GreenShopBanner';

export default GreenShopBanner;
